import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import CssTransition from '../../components/Transition/CssTransition';
import { connect } from 'react-redux';

import {
    RepOverlayContainer,
    RepOverlayBody,
    RepOverlayHeader,
    RepAction,
    RepSection,
    CloseButton,
    OverlayBackground
} from '../../components/Overlay/OverlayComponents';

import { RoundImage } from '../../components/Image/RoundImage';
import {
    setOverlayRepStanceVisible,
    setOverlayPartnerVisible
} from '../../containers/Widget/actions';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { parseVoteSmartCopy, districtInfo } from '../../utils/localRepresentative/parser';
import { cacheFormData } from '../../utils/formCaching/actions';
import ThemeContext from '../../utils/theming';
import { copyFor } from '../../copy/copy';

const OverlayRepStance = props => {
    const theme = useContext(ThemeContext);
    return (
        <CssTransition in={props.isVisible}>
            <OverlayBackground
                isVisible={props.isVisible}
                onClick={() => props.setOverlayRepStanceVisible(false, null)}
            >
                <CssTransition in={props.isVisible}>
                    <RepOverlayContainer
                        isVisible={props.isVisible}
                        onClick={proxy => proxy.stopPropagation()}
                        transitionType={props.transitionType}
                    >
                        <CloseButton
                            style={{ float: 'right' }}
                            onClick={() => props.setOverlayRepStanceVisible(false, null)}
                        >
                            +
                        </CloseButton>
                        <RepOverlayHeader>
                            <h3>
                                {props.rep.title} {props.rep.fullName}&nbsp;
                                {districtInfo(props.rep)}
                            </h3>
                            <RoundImage
                                style={{ margin: '0 1em' }}
                                size={64}
                                src={props.rep.photoUrl || ''}
                            />
                        </RepOverlayHeader>
                        <RepOverlayBody
                            theme={theme}
                            nextAction={props.nextAction}
                            isPartnerOrPublisherOverlay={
                                props.isPartnerOrPublisherOverlay
                            }
                        >
                            <RepSection>
                                <h4>{'OFFICE'}</h4>
                                <p>{props.rep.officeName}</p>
                            </RepSection>
                            <RepSection>
                                <h4>{'ANSWER'}</h4>
                                <p
                                    onClick={e => {
                                        if (e.target.id === 'votesmart') {
                                            props.setOverlayRepStanceVisible(false, null);
                                            setTimeout(e => {
                                                props.setOverlayPartnerVisible(
                                                    true,
                                                    e,
                                                    false,
                                                    false,
                                                    true
                                                );
                                            }, 300);
                                        }
                                    }}
                                    dangerouslySetInnerHTML={{ __html: props.answerCopy }}
                                />
                            </RepSection>
                        </RepOverlayBody>
                        {props.nextAction && (
                            <RepAction
                                theme={theme}
                                onClick={() => {
                                    props.setOverlayRepStanceVisible(false, null);
                                    if (!!props.handleCompleteAction) {
                                        // TIMEOUT TO MATCH DRAWER CLOSING BEFORE TRANSITION
                                        setTimeout(
                                            () => props.handleCompleteAction(),
                                            300
                                        );
                                    }
                                }}
                            >
                                <span>{props.nextActionLabel}</span>
                            </RepAction>
                        )}
                    </RepOverlayContainer>
                </CssTransition>
            </OverlayBackground>
        </CssTransition>
    );
};
OverlayRepStance.propTypes = {
    handleCompleteAction: PropTypes.func.isRequired,
    isPartnerOrPublisherOverlay: PropTypes.bool,
    nextAction: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    nextActionLabel: PropTypes.string,
    answerCopy: PropTypes.string,
    rep: PropTypes.object.isRequired,
    setOverlayRepStanceVisible: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    transitionType: PropTypes.string
};

export default connect(
    state => {
        const rep =
            state.repStance.stances.find(
                r => r.voteSmartCandidateId === state.widget.selectedVoteSmartId
            ) || {};

        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            rep,
            answerCopy: (parseVoteSmartCopy(rep) || '')
                .replace(
                    new RegExp(`Vote Smart's`),
                    `<span id="votesmart">Vote Smart's</span>`
                )
                .replace(
                    new RegExp('Vote Smart'),
                    '<span id="votesmart">Vote Smart</span>'
                )
                .concat(
                    `<br/><br/> Learn more about ${
                        rep.displayName
                    } and other representatives stances on <a href="https://votesmart.org/candidate/political-courage-test/${
                        rep.voteSmartCandidateId
                    }/" target="_blank" rel="noopener noreferrer">Vote Smart</a>.`
                ),
            activeAction: state.widget.activeAction,
            isVisible: state.widget.isRepStanceVisible,
            isMobileResolution: state.widget.isMobileResolution,
            isPartnerOrPublisherOverlay: true,
            nextActionLabel: nextAction?.customButtonText ||
                (nextAction?.type && copyFor('buttons', 'start', nextAction.type)) || 'CONTACT'
        };
    },
    {
        cacheFormData,
        setOverlayRepStanceVisible,
        setOverlayPartnerVisible
    }
)(OverlayRepStance);
